module.exports = __webpack_public_path__ + "static/easy-setup-and-use-805f1129be9c56999525de13d608fea9.png";